module.exports = __webpack_public_path__ + "img/intellectual-aggression.2811ddfe.svg";